document.addEventListener("DOMContentLoaded", function () {
  const tabButtons = document.querySelectorAll(".tab-btn");
  const tabContents = document.querySelectorAll(".tab-content");

  tabButtons.forEach(btn => {
    btn.addEventListener("click", () => {
      tabButtons.forEach(b => b.classList.remove("active"));
      tabContents.forEach(c => c.classList.remove("active"));

      btn.classList.add("active");
      document.getElementById(btn.dataset.tab).classList.add("active");
    });
  });
});

const player = document.getElementById('videoPlayer');

let currentVideo = player ? player.dataset.video : "";

function playVideo(videoUrl) {
  player.innerHTML = `<iframe width="560" height="315" src="${videoUrl}" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>`;
}

document.querySelectorAll('.video-thumb').forEach(btn => {
  btn.addEventListener('click', function () {
    currentVideo = this.dataset.video;
    playVideo(currentVideo);
  });
});

player.addEventListener('click', function () {
  if (currentVideo) {
    playVideo(currentVideo);
  }
});

document.addEventListener('DOMContentLoaded', function () {

  /* ==========================================
     PRODUCT RANGE SLIDER
     ========================================== */

  const sliders = document.querySelectorAll('.range-slider-wrapper');

  sliders.forEach(wrapper => {

    const slider = wrapper.querySelector('.range-slider');
    const prevBtn = wrapper.querySelector('.slider-arrow.prev');
    const nextBtn = wrapper.querySelector('.slider-arrow.next');

    if (!slider) return;

    function getScrollAmount() {
      const card = slider.querySelector('.range-card');
      if (!card) return 300;

      // On mobile, card width = full width
      // On desktop, it keeps original width
      return card.offsetWidth;
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        slider.scrollBy({
          left: getScrollAmount(),
          behavior: 'smooth'
        });
      });
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        slider.scrollBy({
          left: -getScrollAmount(),
          behavior: 'smooth'
        });
      });
    }

  });



  /* ==========================================
     PRODUCT PAGE MEDIA ARROWS
     ========================================== */

  const mediaWrapper = document.querySelector('.product-media-wrapper');
  if (!mediaWrapper) return;

  const prevArrow = mediaWrapper.querySelector('.media-prev');
  const nextArrow = mediaWrapper.querySelector('.media-next');
  if (!prevArrow || !nextArrow) return;

  const mediaItems = mediaWrapper.querySelectorAll('.product__media-item');

  if (!mediaItems || mediaItems.length <= 1) {
    prevArrow.style.display = 'none';
    nextArrow.style.display = 'none';
    return;
  }

  function getActiveIndex(items) {
    return Array.from(items).findIndex(item =>
      item.classList.contains('is-active')
    );
  }

  function activateByIndex(items, index) {
    const mediaId = items[index].dataset.mediaId;

    const thumb = document.querySelector(
      `.thumbnail-list__item[data-target$="${mediaId}"] button.thumbnail`
    );

    if (thumb) thumb.click();
  }

  nextArrow.addEventListener('click', () => {
    const index = getActiveIndex(mediaItems);
    if (index > -1 && index < mediaItems.length - 1) {
      activateByIndex(mediaItems, index + 1);
    }
  });

  prevArrow.addEventListener('click', () => {
    const index = getActiveIndex(mediaItems);
    if (index > 0) {
      activateByIndex(mediaItems, index - 1);
    }
  });

});